import { render, staticRenderFns } from "./inventory-stocks.vue?vue&type=template&id=59c8fe34&"
import script from "./inventory-stocks.vue?vue&type=script&lang=js&"
export * from "./inventory-stocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports